function getFocusableElements(e) {
    return Array.from(e.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"));
}
class SectionId {
    static #a = "__";
    static parseId(e) {
        return e.split(SectionId.#a)[0];
    }
    static parseSectionName(e) {
        return e.split(SectionId.#a)[1];
    }
    static getIdForSection(e, t) {
        return `${e}${SectionId.#a}${t}`;
    }
}
class HTMLUpdateUtility {
    static viewTransition(e, t, i = [], s = []) {
        i?.forEach((e) => e(t));
        let n = document.createElement("div");
        HTMLUpdateUtility.setInnerHTML(n, t.outerHTML);
        let r = n.firstChild,
            o = Date.now();
        e.querySelectorAll("[id], [form]").forEach((e) => {
            e.id && (e.id = `${e.id}-${o}`), e.form && e.setAttribute("form", `${e.form.getAttribute("id")}-${o}`);
        }),
            e.parentNode.insertBefore(r, e),
            (e.style.display = "none"),
            s?.forEach((e) => e(r)),
            setTimeout(() => e.remove(), 500);
    }
    static setInnerHTML(e, t) {
        (e.innerHTML = t),
            e.querySelectorAll("script").forEach((e) => {
                let t = document.createElement("script");
                Array.from(e.attributes).forEach((e) => {
                    t.setAttribute(e.name, e.value);
                }),
                    t.appendChild(document.createTextNode(e.innerHTML)),
                    e.parentNode.replaceChild(t, e);
            });
    }
}
document.querySelectorAll('[id^="Details-"] summary').forEach((e) => {
    e.setAttribute("role", "button"),
        e.setAttribute("aria-expanded", e.parentNode.hasAttribute("open")),
        e.nextElementSibling.getAttribute("id") && e.setAttribute("aria-controls", e.nextElementSibling.id),
        e.addEventListener("click", (e) => {
            e.currentTarget.setAttribute("aria-expanded", !e.currentTarget.closest("details").hasAttribute("open"));
        }),
        e.closest("header-drawer, menu-drawer") || e.parentElement.addEventListener("keyup", onKeyUpEscape);
});
const trapFocusHandlers = {};
function trapFocus(e, t = e) {
    var i = getFocusableElements(e),
        s = i[0],
        n = i[i.length - 1];
    removeTrapFocus(),
        (trapFocusHandlers.focusin = (t) => {
            (t.target === e || t.target === n || t.target === s) && document.addEventListener("keydown", trapFocusHandlers.keydown);
        }),
        (trapFocusHandlers.focusout = function () {
            document.removeEventListener("keydown", trapFocusHandlers.keydown);
        }),
        (trapFocusHandlers.keydown = function (t) {
            "TAB" === t.code.toUpperCase() && (t.target !== n || t.shiftKey || (t.preventDefault(), s.focus()), (t.target === e || t.target === s) && t.shiftKey && (t.preventDefault(), n.focus()));
        }),
        document.addEventListener("focusout", trapFocusHandlers.focusout),
        document.addEventListener("focusin", trapFocusHandlers.focusin),
        t.focus(),
        "INPUT" === t.tagName && ["search", "text", "email", "url"].includes(t.type) && t.value && t.setSelectionRange(0, t.value.length);
}
try {
    document.querySelector(":focus-visible");
} catch (e) {
    focusVisiblePolyfill();
}
function focusVisiblePolyfill() {
    let e = ["ARROWUP", "ARROWDOWN", "ARROWLEFT", "ARROWRIGHT", "TAB", "ENTER", "SPACE", "ESCAPE", "HOME", "END", "PAGEUP", "PAGEDOWN"],
        t = null,
        i = null;
    window.addEventListener("keydown", (t) => {
        e.includes(t.code.toUpperCase()) && (i = !1);
    }),
        window.addEventListener("mousedown", (e) => {
            i = !0;
        }),
        window.addEventListener(
            "focus",
            () => {
                t && t.classList.remove("focused"), i || (t = document.activeElement).classList.add("focused");
            },
            !0
        );
}
function pauseAllMedia() {
    document.querySelectorAll(".js-youtube").forEach((e) => {
        e.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");
    }),
        document.querySelectorAll(".js-vimeo").forEach((e) => {
            e.contentWindow.postMessage('{"method":"pause"}', "*");
        }),
        document.querySelectorAll("video").forEach((e) => e.pause()),
        document.querySelectorAll("product-model").forEach((e) => {
            e.modelViewerUI && e.modelViewerUI.pause();
        });
}
function removeTrapFocus(e = null) {
    document.removeEventListener("focusin", trapFocusHandlers.focusin), document.removeEventListener("focusout", trapFocusHandlers.focusout), document.removeEventListener("keydown", trapFocusHandlers.keydown), e && e.focus();
}
function onKeyUpEscape(e) {
    if ("ESCAPE" !== e.code.toUpperCase()) return;
    let t = e.target.closest("details[open]");
    if (!t) return;
    let i = t.querySelector("summary");
    t.removeAttribute("open"), i.setAttribute("aria-expanded", !1), i.focus();
}
class QuantityInput extends HTMLElement {
    constructor() {
        super(),
            (this.input = this.querySelector("input")),
            (this.changeEvent = new Event("change", { bubbles: !0 })),
            this.input.addEventListener("change", this.onInputChange.bind(this)),
            this.querySelectorAll("button").forEach((e) => e.addEventListener("click", this.onButtonClick.bind(this)));
    }
    quantityUpdateUnsubscriber = void 0;
    connectedCallback() {
        this.validateQtyRules(), (this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this)));
    }
    disconnectedCallback() {
        this.quantityUpdateUnsubscriber && this.quantityUpdateUnsubscriber();
    }
    onInputChange(e) {
        this.validateQtyRules();
    }
    onButtonClick(e) {
        e.preventDefault();
        let t = this.input.value;
        "plus" === e.target.name ? (parseInt(this.input.dataset.min) > parseInt(this.input.step) && 0 == this.input.value ? (this.input.value = this.input.dataset.min) : this.input.stepUp()) : this.input.stepDown(),
            t !== this.input.value && this.input.dispatchEvent(this.changeEvent),
            this.input.dataset.min === t && "minus" === e.target.name && (this.input.value = parseInt(this.input.min));
    }
    validateQtyRules() {
        let e = parseInt(this.input.value);
        if (this.input.min) {
            let t = this.querySelector(".quantity__button[name='minus']");
            t.classList.toggle("disabled", parseInt(e) <= parseInt(this.input.min));
        }
        if (this.input.max) {
            let i = parseInt(this.input.max),
                s = this.querySelector(".quantity__button[name='plus']");
            s.classList.toggle("disabled", e >= i);
        }
    }
}
function debounce(e, t) {
    let i;
    return (...s) => {
        clearTimeout(i), (i = setTimeout(() => e.apply(this, s), t));
    };
}
function throttle(e, t) {
    let i = 0;
    return function (...s) {
        let n = new Date().getTime();
        if (!(n - i < t)) return (i = n), e(...s);
    };
}
function fetchConfig(e = "json") {
    return { method: "POST", headers: { "Content-Type": "application/json", Accept: `application/${e}` } };
}
customElements.define("quantity-input", QuantityInput),
    void 0 === window.Shopify && (window.Shopify = {}),
    (Shopify.bind = function (e, t) {
        return function () {
            return e.apply(t, arguments);
        };
    }),
    (Shopify.setSelectorByValue = function (e, t) {
        for (var i = 0, s = e.options.length; i < s; i++) {
            var n = e.options[i];
            if (t == n.value || t == n.innerHTML) return (e.selectedIndex = i), i;
        }
    }),
    (Shopify.addListener = function (e, t, i) {
        e.addEventListener ? e.addEventListener(t, i, !1) : e.attachEvent("on" + t, i);
    }),
    (Shopify.postLink = function (e, t) {
        var i = (t = t || {}).method || "post",
            s = t.parameters || {},
            n = document.createElement("form");
        for (var r in (n.setAttribute("method", i), n.setAttribute("action", e), s)) {
            var o = document.createElement("input");
            o.setAttribute("type", "hidden"), o.setAttribute("name", r), o.setAttribute("value", s[r]), n.appendChild(o);
        }
        document.body.appendChild(n), n.submit(), document.body.removeChild(n);
    }),
    (Shopify.CountryProvinceSelector = function (e, t, i) {
        (this.countryEl = document.getElementById(e)),
            (this.provinceEl = document.getElementById(t)),
            (this.provinceContainer = document.getElementById(i.hideElement || t)),
            Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this)),
            this.initCountry(),
            this.initProvince();
    }),
    (Shopify.CountryProvinceSelector.prototype = {
        initCountry: function () {
            var e = this.countryEl.getAttribute("data-default");
            Shopify.setSelectorByValue(this.countryEl, e), this.countryHandler();
        },
        initProvince: function () {
            var e = this.provinceEl.getAttribute("data-default");
            e && this.provinceEl.options.length > 0 && Shopify.setSelectorByValue(this.provinceEl, e);
        },
        countryHandler: function (e) {
            var t = this.countryEl.options[this.countryEl.selectedIndex],
                i = JSON.parse(t.getAttribute("data-provinces"));
            if ((this.clearOptions(this.provinceEl), i && 0 == i.length)) this.provinceContainer.style.display = "none";
            else {
                for (var s = 0; s < i.length; s++) {
                    var t = document.createElement("option");
                    (t.value = i[s][0]), (t.innerHTML = i[s][1]), this.provinceEl.appendChild(t);
                }
                this.provinceContainer.style.display = "";
            }
        },
        clearOptions: function (e) {
            for (; e.firstChild; ) e.removeChild(e.firstChild);
        },
        setOptions: function (e, t) {
            for (var i = 0; i < t.length; i++) {
                var s = document.createElement("option");
                (s.value = t[i]), (s.innerHTML = t[i]), e.appendChild(s);
            }
            t.length;
        },
    });
class MenuDrawer extends HTMLElement {
    constructor() {
        super(), (this.mainDetailsToggle = this.querySelector("details")), this.addEventListener("keyup", this.onKeyUp.bind(this)), this.addEventListener("focusout", this.onFocusOut.bind(this)), this.bindEvents();
    }
    bindEvents() {
        this.querySelectorAll("summary").forEach((e) => e.addEventListener("click", this.onSummaryClick.bind(this))),
            this.querySelectorAll("button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)").forEach((e) => e.addEventListener("click", this.onCloseButtonClick.bind(this)));
    }
    onKeyUp(e) {
        if ("ESCAPE" !== e.code.toUpperCase()) return;
        let t = e.target.closest("details[open]");
        t && (t === this.mainDetailsToggle ? this.closeMenuDrawer(e, this.mainDetailsToggle.querySelector("summary")) : this.closeSubmenu(t));
    }
    onSummaryClick(e) {
        let t = e.currentTarget,
            i = t.parentNode,
            s = i.closest(".has-submenu"),
            n = i.hasAttribute("open"),
            r = window.matchMedia("(prefers-reduced-motion: reduce)");
        function o() {
            trapFocus(t.nextElementSibling, i.querySelector("button")), t.nextElementSibling.removeEventListener("transitionend", o);
        }
        i === this.mainDetailsToggle
            ? (n && e.preventDefault(), n ? this.closeMenuDrawer(e, t) : this.openMenuDrawer(t), window.matchMedia("(max-width: 990px)") && document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`))
            : setTimeout(() => {
                  i.classList.add("menu-opening"), t.setAttribute("aria-expanded", !0), s && s.classList.add("submenu-open"), !r || r.matches ? o() : t.nextElementSibling.addEventListener("transitionend", o);
              }, 100);
    }
    openMenuDrawer(e) {
        setTimeout(() => {
            this.mainDetailsToggle.classList.add("menu-opening");
        }),
            e.setAttribute("aria-expanded", !0),
            trapFocus(this.mainDetailsToggle, e),
            document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }
    closeMenuDrawer(e, t = !1) {
        void 0 !== e &&
            (this.mainDetailsToggle.classList.remove("menu-opening"),
            this.mainDetailsToggle.querySelectorAll("details").forEach((e) => {
                e.removeAttribute("open"), e.classList.remove("menu-opening");
            }),
            this.mainDetailsToggle.querySelectorAll(".submenu-open").forEach((e) => {
                e.classList.remove("submenu-open");
            }),
            document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`),
            removeTrapFocus(t),
            this.closeAnimation(this.mainDetailsToggle),
            e instanceof KeyboardEvent && t?.setAttribute("aria-expanded", !1));
    }
    onFocusOut() {
        setTimeout(() => {
            this.mainDetailsToggle.hasAttribute("open") && !this.mainDetailsToggle.contains(document.activeElement) && this.closeMenuDrawer();
        });
    }
    onCloseButtonClick(e) {
        let t = e.currentTarget.closest("details");
        this.closeSubmenu(t);
    }
    closeSubmenu(e) {
        let t = e.closest(".submenu-open");
        t && t.classList.remove("submenu-open"), e.classList.remove("menu-opening"), e.querySelector("summary").setAttribute("aria-expanded", !1), removeTrapFocus(e.querySelector("summary")), this.closeAnimation(e);
    }
    closeAnimation(e) {
        let t,
            i = (s) => {
                void 0 === t && (t = s);
                let n = s - t;
                n < 400 ? window.requestAnimationFrame(i) : (e.removeAttribute("open"), e.closest("details[open]") && trapFocus(e.closest("details[open]"), e.querySelector("summary")));
            };
        window.requestAnimationFrame(i);
    }
}
customElements.define("menu-drawer", MenuDrawer);
class HeaderDrawer extends MenuDrawer {
    constructor() {
        super();
    }
    openMenuDrawer(e) {
        (this.header = this.header || document.querySelector(".section-header")),
            (this.borderOffset = this.borderOffset || this.closest(".header-wrapper").classList.contains("header-wrapper--border-bottom") ? 1 : 0),
            document.documentElement.style.setProperty("--header-bottom-position", `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`),
            this.header.classList.add("menu-open"),
            setTimeout(() => {
                this.mainDetailsToggle.classList.add("menu-opening");
            }),
            e.setAttribute("aria-expanded", !0),
            window.addEventListener("resize", this.onResize),
            trapFocus(this.mainDetailsToggle, e),
            document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }
    closeMenuDrawer(e, t) {
        t && (super.closeMenuDrawer(e, t), this.header.classList.remove("menu-open"), window.removeEventListener("resize", this.onResize));
    }
    onResize = () => {
        this.header && document.documentElement.style.setProperty("--header-bottom-position", `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`),
            document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`);
    };
}
customElements.define("header-drawer", HeaderDrawer);
class ModalDialog extends HTMLElement {
    constructor() {
        super(),
            this.querySelector('[id^="ModalClose-"]').addEventListener("click", this.hide.bind(this, !1)),
            this.addEventListener("keyup", (e) => {
                "ESCAPE" === e.code.toUpperCase() && this.hide();
            }),
            this.classList.contains("media-modal")
                ? this.addEventListener("pointerup", (e) => {
                      "mouse" !== e.pointerType || e.target.closest("deferred-media, product-model") || this.hide();
                  })
                : this.addEventListener("click", (e) => {
                      e.target === this && this.hide();
                  });
    }
    connectedCallback() {
        this.moved || ((this.moved = !0), document.body.appendChild(this));
    }
    show(e) {
        this.openedBy = e;
        let t = this.querySelector(".template-popup");
        document.body.classList.add("overflow-hidden"), this.setAttribute("open", ""), t && t.loadContent(), trapFocus(this, this.querySelector('[role="dialog"]')), window.pauseAllMedia();
    }
    hide() {
        document.body.classList.remove("overflow-hidden"), document.body.dispatchEvent(new CustomEvent("modalClosed")), this.removeAttribute("open"), removeTrapFocus(this.openedBy), window.pauseAllMedia();
    }
}
customElements.define("modal-dialog", ModalDialog);
class BulkModal extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        let e = (e, t) => {
            if (e[0].isIntersecting && (t.unobserve(this), "" === this.innerHTML.trim())) {
                let i = this.dataset.url.split("?")[0];
                fetch(`${i}?section_id=bulk-quick-order-list`)
                    .then((e) => e.text())
                    .then((e) => {
                        let t = new DOMParser().parseFromString(e, "text/html"),
                            i = t.querySelector(".quick-order-list-container").parentNode;
                        this.innerHTML = i.innerHTML;
                    })
                    .catch((e) => {
                        console.error(e);
                    });
            }
        };
        new IntersectionObserver(e.bind(this)).observe(document.querySelector(`#QuickBulk-${this.dataset.productId}-${this.dataset.sectionId}`));
    }
}
customElements.define("bulk-modal", BulkModal);
class ModalOpener extends HTMLElement {
    constructor() {
        super();
        let e = this.querySelector("button");
        if (!e) return;
        e.addEventListener("click", () => {
            let t = document.querySelector(this.getAttribute("data-modal"));
            t && t.show(e);
        });
    }
}
customElements.define("modal-opener", ModalOpener);
class DeferredMedia extends HTMLElement {
    constructor() {
        super();
        let e = this.querySelector('[id^="Deferred-Poster-"]');
        if (!e) return;
        e.addEventListener("click", this.loadContent.bind(this));
    }
    loadContent(e = !0) {
        if ((window.pauseAllMedia(), !this.getAttribute("loaded"))) {
            let t = document.createElement("div");
            t.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(!0)), this.setAttribute("loaded", !0);
            let i = this.appendChild(t.querySelector("video, model-viewer, iframe"));
            e && i.focus(), "VIDEO" == i.nodeName && i.getAttribute("autoplay") && i.play();
        }
    }
}
customElements.define("deferred-media", DeferredMedia);
class SliderComponent extends HTMLElement {
    constructor() {
        if (
            (super(),
            (this.slider = this.querySelector('[id^="Slider-"]')),
            (this.sliderItems = this.querySelectorAll('[id^="Slide-"]')),
            (this.enableSliderLooping = !1),
            (this.currentPageElement = this.querySelector(".slider-counter--current")),
            (this.pageTotalElement = this.querySelector(".slider-counter--total")),
            (this.prevButton = this.querySelector('button[name="previous"]')),
            (this.nextButton = this.querySelector('button[name="next"]')),
            !this.slider || !this.nextButton)
        )
            return;
        this.initPages();
        let e = new ResizeObserver((e) => this.initPages());
        e.observe(this.slider),
            this.slider.addEventListener("scroll", this.update.bind(this)),
            this.prevButton.addEventListener("click", this.onButtonClick.bind(this)),
            this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
    }
    initPages() {
        (this.sliderItemsToShow = Array.from(this.sliderItems).filter((e) => e.clientWidth > 0)),
            this.sliderItemsToShow.length < 2 ||
                ((this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft),
                (this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset)),
                (this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1),
                this.update());
    }
    resetPages() {
        (this.sliderItems = this.querySelectorAll('[id^="Slide-"]')), this.initPages();
    }
    update() {
        if (!this.slider || !this.nextButton) return;
        let e = this.currentPage;
        (this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1),
            this.currentPageElement && this.pageTotalElement && ((this.currentPageElement.textContent = this.currentPage), (this.pageTotalElement.textContent = this.totalPages)),
            this.currentPage != e && this.dispatchEvent(new CustomEvent("slideChanged", { detail: { currentPage: this.currentPage, currentElement: this.sliderItemsToShow[this.currentPage - 1] } })),
            this.enableSliderLooping ||
                (this.isSlideVisible(this.sliderItemsToShow[0]) && 0 === this.slider.scrollLeft ? this.prevButton.setAttribute("disabled", "disabled") : this.prevButton.removeAttribute("disabled"),
                this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1]) ? this.nextButton.setAttribute("disabled", "disabled") : this.nextButton.removeAttribute("disabled"));
    }
    isSlideVisible(e, t = 0) {
        let i = this.slider.clientWidth + this.slider.scrollLeft - t;
        return e.offsetLeft + e.clientWidth <= i && e.offsetLeft >= this.slider.scrollLeft;
    }
    onButtonClick(e) {
        e.preventDefault();
        let t = e.currentTarget.dataset.step || 1;
        (this.slideScrollPosition = "next" === e.currentTarget.name ? this.slider.scrollLeft + t * this.sliderItemOffset : this.slider.scrollLeft - t * this.sliderItemOffset), this.setSlidePosition(this.slideScrollPosition);
    }
    setSlidePosition(e) {
        this.slider.scrollTo({ left: e });
    }
}
customElements.define("slider-component", SliderComponent);
class SlideshowComponent extends SliderComponent {
    constructor() {
        if ((super(), (this.sliderControlWrapper = this.querySelector(".slider-buttons")), (this.enableSliderLooping = !0), !this.sliderControlWrapper)) return;
        (this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide")),
            this.sliderItemsToShow.length > 0 && (this.currentPage = 1),
            (this.announcementBarSlider = this.querySelector(".announcement-bar-slider")),
            (this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0),
            (this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll(".slider-counter__link"))),
            this.sliderControlLinksArray.forEach((e) => e.addEventListener("click", this.linkToSlide.bind(this))),
            this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this)),
            this.setSlideVisibility(),
            this.announcementBarSlider &&
                ((this.announcementBarArrowButtonWasClicked = !1),
                (this.reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)")),
                this.reducedMotion.addEventListener("change", () => {
                    "true" === this.slider.getAttribute("data-autoplay") && this.setAutoPlay();
                }),
                [this.prevButton, this.nextButton].forEach((e) => {
                    e.addEventListener(
                        "click",
                        () => {
                            this.announcementBarArrowButtonWasClicked = !0;
                        },
                        { once: !0 }
                    );
                })),
            "true" === this.slider.getAttribute("data-autoplay") && this.setAutoPlay();
    }
    setAutoPlay() {
        (this.autoplaySpeed = 1e3 * this.slider.dataset.speed),
            this.addEventListener("mouseover", this.focusInHandling.bind(this)),
            this.addEventListener("mouseleave", this.focusOutHandling.bind(this)),
            this.addEventListener("focusin", this.focusInHandling.bind(this)),
            this.addEventListener("focusout", this.focusOutHandling.bind(this)),
            this.querySelector(".slideshow__autoplay")
                ? ((this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay")), this.sliderAutoplayButton.addEventListener("click", this.autoPlayToggle.bind(this)), (this.autoplayButtonIsSetToPlay = !0), this.play())
                : this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
                ? this.pause()
                : this.play();
    }
    onButtonClick(e) {
        super.onButtonClick(e), (this.wasClicked = !0);
        let t = 1 === this.currentPage,
            i = this.currentPage === this.sliderItemsToShow.length;
        if (!t && !i) {
            this.applyAnimationToAnnouncementBar(e.currentTarget.name);
            return;
        }
        t && "previous" === e.currentTarget.name
            ? (this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length)
            : i && "next" === e.currentTarget.name && (this.slideScrollPosition = 0),
            this.setSlidePosition(this.slideScrollPosition),
            this.applyAnimationToAnnouncementBar(e.currentTarget.name);
    }
    setSlidePosition(e) {
        this.setPositionTimeout && clearTimeout(this.setPositionTimeout),
            (this.setPositionTimeout = setTimeout(() => {
                this.slider.scrollTo({ left: e });
            }, this.announcerBarAnimationDelay));
    }
    update() {
        super.update(),
            (this.sliderControlButtons = this.querySelectorAll(".slider-counter__link")),
            this.prevButton.removeAttribute("disabled"),
            this.sliderControlButtons.length &&
                (this.sliderControlButtons.forEach((e) => {
                    e.classList.remove("slider-counter__link--active"), e.removeAttribute("aria-current");
                }),
                this.sliderControlButtons[this.currentPage - 1].classList.add("slider-counter__link--active"),
                this.sliderControlButtons[this.currentPage - 1].setAttribute("aria-current", !0));
    }
    autoPlayToggle() {
        this.togglePlayButtonState(this.autoplayButtonIsSetToPlay), this.autoplayButtonIsSetToPlay ? this.pause() : this.play(), (this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay);
    }
    focusOutHandling(e) {
        if (this.sliderAutoplayButton) {
            let t = e.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(e.target);
            this.autoplayButtonIsSetToPlay && !t && this.play();
        } else this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked || this.play();
    }
    focusInHandling(e) {
        if (this.sliderAutoplayButton) {
            let t = e.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(e.target);
            t && this.autoplayButtonIsSetToPlay ? this.play() : this.autoplayButtonIsSetToPlay && this.pause();
        } else this.announcementBarSlider.contains(e.target) && this.pause();
    }
    play() {
        this.slider.setAttribute("aria-live", "off"), clearInterval(this.autoplay), (this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed));
    }
    pause() {
        this.slider.setAttribute("aria-live", "polite"), clearInterval(this.autoplay);
    }
    togglePlayButtonState(e) {
        e
            ? (this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused"), this.sliderAutoplayButton.setAttribute("aria-label", window.accessibilityStrings.playSlideshow))
            : (this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused"), this.sliderAutoplayButton.setAttribute("aria-label", window.accessibilityStrings.pauseSlideshow));
    }
    autoRotateSlides() {
        let e = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;
        this.setSlidePosition(e), this.applyAnimationToAnnouncementBar();
    }
    setSlideVisibility(e) {
        this.sliderItemsToShow.forEach((e, t) => {
            let i = e.querySelectorAll("a");
            t === this.currentPage - 1
                ? (i.length &&
                      i.forEach((e) => {
                          e.removeAttribute("tabindex");
                      }),
                  e.setAttribute("aria-hidden", "false"),
                  e.removeAttribute("tabindex"))
                : (i.length &&
                      i.forEach((e) => {
                          e.setAttribute("tabindex", "-1");
                      }),
                  e.setAttribute("aria-hidden", "true"),
                  e.setAttribute("tabindex", "-1"));
        }),
            (this.wasClicked = !1);
    }
    applyAnimationToAnnouncementBar(e = "next") {
        if (!this.announcementBarSlider) return;
        let t = this.sliderItems.length,
            i = this.currentPage - 1,
            s = (i + ("next" === e ? 1 : -1)) % t;
        s = -1 === s ? t - 1 : s;
        let n = this.sliderItems[s],
            r = this.sliderItems[i],
            o = "announcement-bar-slider--fade-in",
            a = "announcement-bar-slider--fade-out",
            l = ("next" === e && i !== t - 1) || ("previous" === e && 0 === i) ? "next" : "previous";
        r.classList.add(`${a}-${l}`),
            n.classList.add(`${o}-${l}`),
            setTimeout(() => {
                r.classList.remove(`${a}-${l}`), n.classList.remove(`${o}-${l}`);
            }, 2 * this.announcerBarAnimationDelay);
    }
    linkToSlide(e) {
        e.preventDefault();
        let t = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(e.currentTarget) + 1 - this.currentPage);
        this.slider.scrollTo({ left: t });
    }
}
customElements.define("slideshow-component", SlideshowComponent);
class VariantSelects extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        this.addEventListener("change", (e) => {
            let t = this.getInputForEventTarget(e.target);
            this.updateSelectionMetadata(e), publish(PUB_SUB_EVENTS.optionValueSelectionChange, { data: { event: e, target: t, selectedOptionValues: this.selectedOptionValues } });
        });
    }
    updateSelectionMetadata({ target: e }) {
        let { value: t, tagName: i } = e;
        if ("SELECT" === i && e.selectedOptions.length) {
            Array.from(e.options)
                .find((e) => e.getAttribute("selected"))
                .removeAttribute("selected"),
                e.selectedOptions[0].setAttribute("selected", "selected");
            let s = e.selectedOptions[0].dataset.optionSwatchValue,
                n = e.closest(".product-form__input").querySelector("[data-selected-value] > .swatch");
            if (!n) return;
            s ? (n.style.setProperty("--swatch--background", s), n.classList.remove("swatch--unavailable")) : (n.style.setProperty("--swatch--background", "unset"), n.classList.add("swatch--unavailable")),
                n.style.setProperty("--swatch-focal-point", e.selectedOptions[0].dataset.optionSwatchFocalPoint || "unset");
        } else if ("INPUT" === i && "radio" === e.type) {
            let r = e.closest(".product-form__input").querySelector("[data-selected-value]");
            r && (r.innerHTML = t);
        }
    }
    getInputForEventTarget(e) {
        return "SELECT" === e.tagName ? e.selectedOptions[0] : e;
    }
    get selectedOptionValues() {
        return Array.from(this.querySelectorAll("select option[selected], fieldset input:checked")).map(({ dataset: e }) => e.optionValueId);
    }
}
customElements.define("variant-selects", VariantSelects);
class ProductRecommendations extends HTMLElement {
    observer = void 0;
    constructor() {
        super();
    }
    connectedCallback() {
        this.initializeRecommendations(this.dataset.productId);
    }
    initializeRecommendations(e) {
        this.observer?.unobserve(this),
            (this.observer = new IntersectionObserver(
                (t, i) => {
                    t[0].isIntersecting && (i.unobserve(this), this.loadRecommendations(e));
                },
                { rootMargin: "0px 0px 400px 0px" }
            )),
            this.observer.observe(this);
    }
    loadRecommendations(e) {
        fetch(`${this.dataset.url}&product_id=${e}&section_id=${this.dataset.sectionId}`)
            .then((e) => e.text())
            .then((e) => {
                let t = document.createElement("div");
                t.innerHTML = e;
                let i = t.querySelector("product-recommendations");
                i?.innerHTML.trim().length && (this.innerHTML = i.innerHTML),
                    !this.querySelector("slideshow-component") && this.classList.contains("complementary-products") && this.remove(),
                    t.querySelector(".grid__item") && this.classList.add("product-recommendations--loaded");
            })
            .catch((e) => {
                console.error(e);
            });
    }
}
customElements.define("product-recommendations", ProductRecommendations);
class AccountIcon extends HTMLElement {
    constructor() {
        super(), (this.icon = this.querySelector(".icon"));
    }
    connectedCallback() {
        document.addEventListener("storefront:signincompleted", this.handleStorefrontSignInCompleted.bind(this));
    }
    handleStorefrontSignInCompleted(e) {
        e?.detail?.avatar && this.icon?.replaceWith(e.detail.avatar.cloneNode());
    }
}
customElements.define("account-icon", AccountIcon);
class BulkAdd extends HTMLElement {
    constructor() {
        super(), (this.queue = []), (this.requestStarted = !1), (this.ids = []);
    }
    startQueue(e, t) {
        this.queue.push({ id: e, quantity: t });
        let i = setInterval(() => {
            this.queue.length > 0 ? this.requestStarted || this.sendRequest(this.queue) : clearInterval(i);
        }, 250);
    }
    sendRequest(e) {
        this.requestStarted = !0;
        let t = {};
        e.forEach((e) => {
            t[parseInt(e.id)] = e.quantity;
        }),
            (this.queue = this.queue.filter((t) => !e.includes(t)));
        let i = this.closest("quick-order-list") || this.closest("quick-add-bulk");
        i.updateMultipleQty(t);
    }
    resetQuantityInput(e) {
        let t = this.querySelector(`#Quantity-${e}`);
        (t.value = t.getAttribute("value")), (this.isEnterPressed = !1);
    }
    setValidity(e, t, i) {
        e.target.setCustomValidity(i), e.target.reportValidity(), this.resetQuantityInput(t), e.target.select();
    }
    validateQuantity(e) {
        let t = parseInt(e.target.value),
            i = e.target.dataset.index;
        t < e.target.dataset.min
            ? this.setValidity(e, i, window.quickOrderListStrings.min_error.replace("[min]", e.target.dataset.min))
            : t > parseInt(e.target.max)
            ? this.setValidity(e, i, window.quickOrderListStrings.max_error.replace("[max]", e.target.max))
            : t % parseInt(e.target.step) != 0
            ? this.setValidity(e, i, window.quickOrderListStrings.step_error.replace("[step]", e.target.step))
            : (e.target.setCustomValidity(""), e.target.reportValidity(), this.startQueue(i, t));
    }
    getSectionsUrl() {
        return window.pageNumber ? `${window.location.pathname}?page=${window.pageNumber}` : `${window.location.pathname}`;
    }
    getSectionInnerHTML(e, t) {
        return new DOMParser().parseFromString(e, "text/html").querySelector(t).innerHTML;
    }
}
customElements.get("bulk-add") || customElements.define("bulk-add", BulkAdd);
